import { Locale as LocaleCore } from '@medable/i18n-core';
export function isRtl(locale) {
    return locale && new LocaleCore(locale.toString()).dir === 'rtl';
}
export function isTime12Hour(locale) {
    var _a;
    return (_a = new LocaleCore(locale.toString()).hour12) !== null && _a !== void 0 ? _a : false;
}
//# sourceMappingURL=i18n_utils.js.map